<div class="table-wrapper pdb-30">
  @if (data) {
    <table>
      <thead>
        <tr>
          <td class="no-border"></td>
          <th scope="colgroup" class="header centered bold border-bold-left border-bold-right" [attr.colspan]="colCount + 1"
            translate>
          {{rowHeader}}</th>
        </tr>
        <tr>
          <th scope="col" class="header centered bold border-bold-left border-bold-right" translate>
          {{columnHeader}}</th>
          @for (n of [].constructor(colCount); track n; let colIndex = $index) {
            <th scope="col" class="centered">{{colIndex + 1}}
            </th>
          }
          <th scope="col" class="centered border-bold-left border-bold-right" translate>
          m1.sprint10.cockpit-kontrolle.matrix-total-table.total</th>
        </tr>
      </thead>
      <tbody>
        @for (n of [].constructor(rowCount); track n; let rowIndex = $index) {
          <tr>
            <th scope="row" class="text-align-left border-bold-left border-bold-right">{{rowIndex + 1}}</th>
            @for (n of [].constructor(colCount); track n; let colIndex = $index) {
              <td class="text-align-right">
              {{data.matrix[rowIndex][colIndex]}}</td>
            }
            <td class="text-align-right border-bold-left border-bold-right">{{data.totalColumn[rowIndex]}}</td>
          </tr>
        }
        <tr>
          <th scope="row" class="text-align-left border-bold-left border-bold-right border-bold-top" translate>
          m1.sprint10.cockpit-kontrolle.matrix-total-table.total</th>
          @for (n of [].constructor(colCount); track n; let colIndex = $index) {
            <td class="text-align-right border-bold-top">
            {{data.totalRow[colIndex]}}</td>
          }
          <td class="text-align-right border-bold-left border-bold-right border-bold-top">{{data.total}}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td class="hint" [attr.colspan]="colCount + 2" translate>
          m1.sprint10.cockpit-kontrolle.matrix-total-table.basis-grundgesamtheit</td>
        </tr>
      </tfoot>
    </table>
  }
</div>
